import { action } from "satcheljs";

import type { OwaNovaActionUnion } from "../types";

export const onOpenLPC = action("onOpenLPC", event => ({
    event,
    owaType: "openLPC",
})) as OwaNovaActionUnion<"openLPC">;
